<template>
	<div>
		<app-app-header v-model="indexStore.isHeaderVisible"
						:title="$t('view.dashboard.title')"
						flat-on-top background main/>

		<app-content>
			<page-content background mobile-tight>
				<container :tight="!$device.isDesktop">
					<row>
						<column cols="12" :md="$device.isDesktop ? 5 : 12">
							<sticky-content :enabled="$device.isDesktop" breakpoint="md">
								<row v-if="!pending" tight>
									<template v-if="$auth.loggedIn">
										<column cols="6" sm="3" md="6">
											<finisher-points-widget :to="$web('my.finisherpoints.store')"/>
										</column>
										<column cols="6" sm="3" md="6">
											<user-widget :user="$auth.user" :to="$web('my.index')" :title="$t('view.my.index.title')"/>
										</column>

										<column v-if="$auth.user && !$auth.user.is_confirmed" cols="12">
											<lazy-confirm-account-alert hide-icon/>
										</column>

										<column v-if="participationEvents?.length" cols="12" sm="6" md="12">
											<div class="mx--16 md:mx-0">
												<slider :show-arrows="$device.isDesktop && participationEvents.length > 1" full-width-spaced>
													<slider-item v-for="participationEvent in participationEvents" :key="'event-participation-' + participationEvent.id">
														<profile-preview v-if="!participationEvent.participations.length" :model="participationEvent.event" :to="$web('events.show', participationEvent.event._key)" class="w-340 sm:w-400 min-w-full"/>
														<card v-else :style="{borderTop: `2px solid ${participationEvent.event.color ?? '#008200'}`}" class="w-340 sm:w-400 min-w-full">
															<event-participations-preview :participations="participationEvent.participations" :event="participationEvent.event" force-mobile-layout/>
															<btn v-if="participationEvents.some(pEvent => pEvent.has_more_participations)" text large class="rounded-t-none border-t" :to="$web('my.events.show', [participationEvent.event._key])" :color="participationEvent.event.color ?? 'primary'">
																<span>{{ $t('action.show_all') }}</span>
																<icon :icon="icons.next"/>
															</btn>
														</card>
													</slider-item>
												</slider>
											</div>

										</column>
									</template>
									<template v-else-if="!$auth.loggedIn">
										<column cols="6" sm="3" md="6">
											<user-widget :to="$web('auth.login')" :title="$t('action.login')"/>
										</column>
										<column cols="6" sm="3" md="6">
											<image-widget :src="`widgets/widget-register.png`" :title="$t('action.create_free_account')"
														  :color="$config.public.colors.primary"
														  :to="$web('auth.register')"/>
										</column>
									</template>

									<column v-if="eventSuggestions && eventSuggestions.length" cols="12">
										<div class="mx--16 md:mx-0">
											<slider :show-arrows="$device.isDesktop" full-width-spaced>
												<slider-item v-for="eventSuggestion in eventSuggestions" :key="'event-suggest-' + eventSuggestion.id">
													<event-card :event="eventSuggestion" :to="$web('events.show', eventSuggestion._key)" class="w-200"/>
												</slider-item>
											</slider>
										</div>
									</column>

									<column cols="6" sm="3" md="6">
										<image-widget :src="'widgets/widget-community.png'" :title="$t('label.community')" :color="$config.public.colors.community" :to="$web('community')"/>
									</column>

									<column cols="6" sm="3" md="6">
										<image-widget :src="'widgets/widget-news.png'" :title="$t('label.news')" :color="$config.public.colors.news" :to="$app('news')"/>
									</column>

									<column cols="6" sm="3" md="6">
										<image-widget :src="'widgets/widget-events.png'" :title="$t('label.competition_calendar')" :color="$config.public.colors.primary" :to="$web('events.index')"/>
									</column>

									<column cols="6" sm="3" md="6">
										<image-widget :src="'widgets/widget-participations.png'" :title="$t('label.competition_planner')" :color="$config.public.colors.primary" to="/competition-planner"/>
									</column>

									<column cols="6" sm="3" md="6">
										<image-widget :src="'widgets/widget-jobs.png'" :title="$t('label.job_portal')" :color="$config.public.colors.jobs" :to="$web('jobs.index')"/>
									</column>

									<column v-if="$auth.user && $auth.user.jobClub" cols="6" sm="3" md="6">
										<club-widget :club="$auth.user.jobClub" :to="$web('jobs.clubs.show', $auth.user.jobClub._key)" title="BTV-Jobs"/>
									</column>

									<column cols="6" sm="3" md="6">
										<image-widget :src="'widgets/widget-my-jobs.png'" :title="$t('label.operation_planner')" color="#3949ab" to="/operation-planner"/>
									</column>

									<column cols="6" sm="3" md="6">
										<image-widget :src="'widgets/widget-results.png'" :title="$t('label.results')" :color="$config.public.colors.primary" to="/results?view=community"/>
									</column>

									<column cols="6" sm="3" md="6">
										<image-widget :src="'widgets/widget-blog.png'" :title="$t('label.sport_blog')" :color="$config.public.colors.blog" :to="$app('blog')"/>
									</column>

									<column cols="6" sm="3" md="6">
										<image-widget :src="'widgets/widget-sports-map.png'" :title="$t('label.sports_map')" :color="$config.public.colors.primary"
													  :to="$web('events.sports_map')"/>
									</column>

									<column cols="6" sm="3" md="6">
										<image-widget :src="'widgets/widget-clubs.png'" :title="$t('label.club_map')" :color="$config.public.colors.secondary"
													  :to="$web('clubs.index')"/>
									</column>
									<column cols="6" sm="3" md="6">
										<image-widget :src="'widgets/widget-athletes.png'" :title="$t('label.athletes')" :color="$config.public.colors.primary"
													  :to="$web('users.index')"/>
									</column>
									<column cols="6" sm="3" md="6">
										<image-widget :src="'widgets/widget-sports.png'" :title="$t('label.sports_directory')" :color="$config.public.colors.primary"
													  :to="$app('sports')"/>
									</column>

									<template v-if="$auth.user && $auth.user.managementClubs?.length">
										<column v-for="managementClub in $auth.user.managementClubs" :key="managementClub.id" cols="6" sm="3" md="6">
											<lazy-club-widget :club="managementClub" :to="$config.public.teamsUrl.replace('{team}', managementClub._key) + authQueryParamSuffix"/>
										</column>
									</template>

									<column cols="6" sm="3" md="6">
										<logo-widget src="/logos/resultastic-logo.png" :ratio="3085/756" title="resultastic"
													 :to="`${$config.public.resultasticUrl}${authQueryParamSuffix}`" color="#008200"/>
									</column>

									<column v-if="$auth.user && $auth.user.is_admin" cols="6" sm="3" md="6">
										<logo-widget src="/logos/spoferan/spoferan-full-logo.png" :ratio="1173/210" title="Adminbereich"
													 :to="`${$config.public.adminUrl}${authQueryParamSuffix}`" color="#008200"/>
									</column>
								</row>
							</sticky-content>
						</column>
						<column v-if="$device.isDesktop" cols="12" md="7">
							<card xs-tile sm-tile class="flex-grow-1">
								<card-text class="p-0" fill>
									<activity-feed id="newsfeed" :url="`/v1/views/community`" flat only-auth-creator with-ads class="mb-64 md:mb-0"/>
								</card-text>
							</card>
						</column>
					</row>
				</container>
			</page-content>
		</app-content>
	</div>
</template>

<script setup lang="ts">
import {useIndexStore} from "../store";
import {nextIcon} from "@spoferan/nuxt-spoferan/icons";

const {$device, $auth} = useNuxtApp();
const {t} = useI18n();
const indexStore = useIndexStore();

const {reactiveData, pending, error} = await useApiFetch('/v1/views/dashboard', {
	auth: $auth.loggedIn
});

const participationEvents = computed(() => {
	return reactiveData.value?.participationEvents;
});

const eventSuggestions = computed(() => {
	return reactiveData.value?.eventSuggestions;
});

const icons = {
	next: nextIcon
}

const authQueryParamSuffix = computed(() => {
	// We pass the auth token for links to our external services to keep the user authenticated
	if ($device.isNative && $auth.token) {
		return `?auth=${$auth.token}`
	}

	return '';
});

useMeta({
	title: t('view.dashboard.title')
});

</script>

